import { render, staticRenderFns } from "./ScreenEdit.vue?vue&type=template&id=5a61db18&scoped=true"
import script from "./ScreenEdit.vue?vue&type=script&lang=js"
export * from "./ScreenEdit.vue?vue&type=script&lang=js"
import style0 from "./ScreenEdit.vue?vue&type=style&index=0&id=5a61db18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61db18",
  null
  
)

export default component.exports